module.exports = __webpack_public_path__ + "static/media/down-arrow.9714dc94.svg";